import { ADDRESS_ERRORS } from '../constants';

export const ERROR = ADDRESS_ERRORS.REQUIRED;

export function AddressRequiredValidator() {
  return {
    require: ['ngModel', '^^form'],
    restrict: 'A',
    link(scope, element, attrs, [modelCtrl, formCtrl]) {
      const handler = scope.$watch(
        () => formCtrl.$submitted,
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            modelCtrl.$validate();
            handler();
          }
        }
      );

      const getRequired = () => scope.$eval(attrs.updAddressRequired) || [];

      modelCtrl.$validators[ERROR] = (modelValue, viewValue) => {
        const value = modelValue || viewValue || {};
        return (
          !formCtrl.$submitted || getRequired().every(field => !!value[field])
        );
      };
    },
  };
}
